import { upload, get, getList } from "./client";
import type { PaginatedResponse } from "../types/api";
import type { Receipt, ReceiptUploadResult } from "../types/receipt";

export async function uploadReceipt(clientId: number, file: File): Promise<ReceiptUploadResult> {
  const formData = new FormData();
  formData.append("file", file);

  return upload<ReceiptUploadResult>(`/api/clients/${clientId}/documents/upload`, formData);
}

export async function getReceipt(clientId: number, docId: number): Promise<Receipt> {
  return get<Receipt>(`/api/clients/${clientId}/documents/${docId}`);
}

export async function listReceipts(
  clientId: number,
  page?: number,
  perPage?: number,
): Promise<PaginatedResponse<Receipt>> {
  const params: Record<string, string> = {};
  if (page !== undefined) {
    params["page"] = String(page);
  }
  if (perPage !== undefined) {
    params["per_page"] = String(perPage);
  }

  return getList<Receipt>(
    `/api/clients/${clientId}/documents`,
    Object.keys(params).length > 0 ? params : undefined,
  );
}

export function getReceiptFileUrl(clientId: number, docId: number): string {
  return `/api/clients/${clientId}/documents/${docId}/file`;
}
